// eslint-disable-next-line import/no-anonymous-default-export
export default {
  black: "#000000",
  red: "#ff0000",
  green: "#00ff00",
  blue: "#0000ff",
  white: "#ffffff",
  polar: "#76d4f8",
  ozone: "#337ace",
  fieldTextHelper: "#7c7c7c",
  fieldBg: "#f3f3f3",
  gainsboro: "#dadada",
  brainstemGrey: "#b6b6b6",
  doveGray: "#707070",
  silverSand: "#c6c6c6",
  platinum: "#e7e7e7",
  gray95: "#f2f2f2",
  primaryOzone: "#348bff",
  primaryOzone900: "#001b40",
  primaryOzone500: "#006dff",
  neutralGrey100: "#FAFAFA",
  neutralGrey200: "#F0F1F2",
  neutralGrey300: "#e7e7e7",
  neutralGrey400: "#d5d9df",
  neutralGrey500: "#B8C2D2",
  neutralGrey600: "#8B95A5",
  neutralGrey700: "#4e5d75",
  neutralGrey800: "#2f405a",
  lightGreen: "#dcf2e3",
  mutedTealGreen: "#56b776",
  accent3Error: "#e12d04",
  solar: "#fdd746",
};
